import React from "react";
import { useSelector } from "react-redux";
import { useGetAllSpwsForACatalogueQuery } from "../../redux/catalogueService";
import SpwFilterData from "./SpwFilterData";

function SpwFilter() {
  const { spwFilterUrl } = useSelector((state) => state.router);

  const { currentData: SPWData, isFetching } =
    useGetAllSpwsForACatalogueQuery(spwFilterUrl);

  return (
    <div>
      <SpwFilterData SPWData={SPWData} isFetching={isFetching} />
    </div>
  );
}

export default SpwFilter;
